import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { ButtonWithIcon } from '@els/els-react--button';

import './SelectedSearchItemTag.scss';

function SelectedSearchItemTag(props) {
  const { item, onClickThesaurusItem } = props;
  const title = item.get('title');

  return (
    <div className="tree-view-dialog-selected-search-items-tag">
      {title}
      <ButtonWithIcon
        type="link"
        size="small"
        linkIconSize="xs"
        sprite="Close"
        iconOnly
        onClick={() => {
          onClickThesaurusItem(item);
        }}
        className="tree-view-dialog-selected-search-items-remove-button e2e-remove"
        aria-label="Remove">
        Remove
      </ButtonWithIcon>
    </div>
  );
}

SelectedSearchItemTag.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  onClickThesaurusItem: PropTypes.func.isRequired,
};

export default SelectedSearchItemTag;
